import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { Link } from 'site-modules/shared/components/link/link';

import './links-item.scss';

export function LinksItem({ componentParams, onRendered = noop }) {
  useEffect(() => {
    onRendered();
  }, [onRendered]);

  const { url, name } = componentParams;

  return (
    <li className="links-item mb-1">
      <Link
        to={url}
        data-tracking-id="click_source_link"
        data-tracking-value={name}
        className="text-decoration-none p-1 d-flex justify-content-between align-items-center"
      >
        <span className="me-0_25 size-16 text-lowercase sentence-case">{name}</span>
        <i className="icon-arrow-right4 size-14 text-cool-gray-40" aria-hidden />
      </Link>
    </li>
  );
}

LinksItem.propTypes = {
  componentParams: PropTypes.shape({
    url: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  onRendered: PropTypes.func,
};
